// extracted by mini-css-extract-plugin
export default {"page":"LegalityScreen_page__o8fGq","content":"LegalityScreen_content__b-dss","container":"LegalityScreen_container__FAZrH"};